// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  requests: [],
  user: null,
  verification: null,
  allVAttributes: null,
  quotes: null,
  budget: null,
  pdf: null,
  multimedia: [],
  peritadorPdf: null,
  actPostRequestsPending: false,
  actPostRequestsSuccess: false,
  actPostRequestsError: null,
  actGetFilterRequestPending: false,
  actGetFilterRequestError: null,
  actPatchRequestsPending: false,
  actPatchRequestsError: null,
  actVerificationPending: false,
  actVerificationError: null,
  actverifiedQuotesPending: false,
  actverifiedQuotesError: null,
  actGetAllVAtrributesPending: false,
  actGetAllVAtrributesError: null,
  actDownloadReportPending: false,
  actDownloadReportError: null,
  actBusinessUnitPending: false,
  actBusinessUnitError: null,
  actBranchOfficePending: false,
  actBranchOfficeError: null,
  actBudgetPending: false,
  actBudgetError: null,
  actDeleteRequestPending: false,
  actDeleteRequestError: null,
  actGetUserPending: false,
  actGetUserError: null,
  actGetMultimediaPending: false,
  actGetMultimediaError: null,
  actGetPdfPending: false,
  actGetPdfError: null,
  requestDialogSteps: [],
  requestDialogCurrentStep: {},
  requestDialogAllStepsCompleted: false,
  requestDialogClient:null,
  requestDialogService:null,
  requestDialogIsValid:false,
  requestDialogValidateGetPeritadoPending: false,
  requestDialogValidateGetPeritadoError: null,
  reportPeritadorPending: false,
  actGetCarGaleryPending: false,
  actGetCarGaleryError: null,
  carGalery: null,
  actGetRequestCustomerPending: false,
  request: {
    customer: {}
  },
  actGetRequestCustomerError: null,
  businessUnit: null,
  actOriginChannelPending: false,
  actOriginChannelError: null,
  originChannels: null,
  patchVerifiedQuotesPending: false,
  patchVerifiedQuotesError: null,
}

export default initialState